<template>
    <div class="animated fadeIn">
        <b-row>
            <b-col>
                <component-header
                    title="Service Request Category Create"
                    :hasSearch="false"
                    :hasReload="false"
                    :hasCreate="false"
                    :hasback="true"
                    @back-press="$router.push('/setup/service-request')"
                />
            </b-col>
            <b-col md="12">
                <ValidationObserver v-slot="{ invalid }" ref="observer">
                    <b-card>
                        <b-row>
                            <b-col md="4">
                                <span>Category</span>
                            </b-col>
                            <b-col md="8">
                                <ValidationProvider
                                    rules="required"
                                    v-slot="{ errors }"
                                    name="Category"
                                >
                                    <c-input
                                        inputType="text"
                                        lableText="Category"
                                        v-model="name"
                                    />
                                    <span class="validate-error">{{
                                        errors[0]
                                    }}</span>
                                </ValidationProvider>
                            </b-col>
                        </b-row>
                        <b-row
                            v-if="
                                userRole === 'Tenant' || userRole === 'Partner'
                            "
                            class="mt-2"
                        >
                            <b-col md="4">
                                <span>Scope</span>
                            </b-col>
                            <b-col md="8">
                                <ValidationProvider
                                    rules="required"
                                    v-slot="{ errors }"
                                    name="Scope"
                                >
                                    <eb-select
                                        type="text"
                                        v-model="scope"
                                        :options="scope1Options"
                                        label="label"
                                        placeholder="Select scope"
                                    ></eb-select>
                                    <span class="validate-error">{{
                                        errors[0]
                                    }}</span>
                                </ValidationProvider>
                            </b-col>
                        </b-row>
                        <b-row v-if="userRole === 'Admin'">
                            <b-col md="4">
                                <span>Scope</span>
                            </b-col>
                            <b-col md="8">
                                <eb-select
                                    type="text"
                                    v-model="scope"
                                    :options="scopeOptions"
                                    label="label"
                                    placeholder="Select scope"
                                ></eb-select>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col md="4">
                                <span>Description</span>
                            </b-col>
                            <b-col md="8">
                                <div class="form-group">
                                    <ValidationProvider
                                        rules="required"
                                        v-slot="{ errors }"
                                        name="Description"
                                    >
                                        <b-form-textarea
                                            v-model="description"
                                            placeholder="Enter something..."
                                            rows="3"
                                            max-rows="6"
                                        ></b-form-textarea>
                                        <span class="validate-error">{{
                                            errors[0]
                                        }}</span>
                                    </ValidationProvider>
                                </div>
                            </b-col>
                        </b-row>
                        <b-row class="mt-2">
                            <b-col md="4">
                                <span>Severity</span>
                            </b-col>
                            <b-col md="8">
                                <ValidationProvider
                                    rules="required"
                                    v-slot="{ errors }"
                                    name="Severity"
                                >
                                    <eb-select
                                        type="text"
                                        v-model="severity"
                                        :options="severityOptions"
                                        label="label"
                                        placeholder="Select Severity"
                                    ></eb-select>
                                    <span class="validate-error">{{
                                        errors[0]
                                    }}</span>
                                </ValidationProvider>
                            </b-col>
                        </b-row>
                    </b-card>
                    <div class="text-center mb-3">
                        <eb-button
                            class="btn mr-4"
                            :disabled="invalid"
                            classic="mr-1 btn-primary"
                            text="Save"
                            @click.prevent="handleSubmit"
                        ></eb-button>
                    </div>
                </ValidationObserver>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import cInput from "@/components/Common/CustomInput";
import ebSelect from "@/components/FormElements/Select.vue";
import ebButton from "@/components/FormElements/Button";
import servicerequestdetails from "@/components/MasterSetup/ServiceRequest/ServiceRequestDetails.vue";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import ComponentHeader from "@/components/componentNewHeader";
export default {
    name: "createrequest",
    components: {
        ebButton,
        cInput,
        ebSelect,
        servicerequestdetails,
        ValidationObserver,
        ValidationProvider,
        ComponentHeader,
    },
    data: () => {
        return {
            show: true,
            scope: "",
            scope1Options: ["AGENT", "PARTNER", "CUSTOMER"],
            scopeOptions: ["TENANT"],
            severityOptions: ["Low", "Medium", "High", "Critical"],
            name: "",
            severity: "",
            description: "",
        };
    },
    computed: {
        userRole() {
            if (this.$store.getters["auth/getUserRole"]) {
                return this.$store.getters["auth/getUserRole"];
            } else {
                return JSON.parse(sessionStorage.getItem("userLogin"))["role"];
            }
        },
    },
    methods: {
        async handleSubmit() {
            const isValid = await this.$refs.observer.validate();
            if (!isValid) return;

            let dataObj;
            dataObj = {
                parent: null,
                scope: this.scope,
                name: this.name,
                description: this.name,
                severity: this.severity,
            };
            try {
                await this.$store.dispatch(
                    "servicerequest/createRequest",
                    dataObj
                );
                this.$swal({
                    title: "Success",
                    text: "Request added successfully!!",
                    type: "success",
                });
                this.$router.push("/setup/service-request");
                await this.$store.dispatch(
                    "servicerequest/fetchServicerequestList"
                    // this.$store.getters["auth/getUserID"]
                );
            } catch (error) {
                this.$toasted.error(error.message);
            }
        },
    },
};
</script>
<style scoped>
.fa-plus {
    border-top-right-radius: 10px;
    border-top-left-radius: 17px;
    border-bottom-left-radius: 17px;
    background-color: #f0f3f5;
}
</style>
